import { AXIOS } from '../components/shared/http-common/http-common'
import { AXIOS_SHARED } from '../components/shared/http-common/http-shared'
import { ENDPOINTS } from '../utils/constant'

const api = {

  getEnvironments () {
    const apiConfig = ENDPOINTS.API.GET_ENVIRONMENT
    return AXIOS.get(apiConfig).then(response => {
      return response.data
    })
  },

  getApiEndPoints (environmentId) {
    const apiEndPointConfig = ENDPOINTS.API.GET_ENVIRONMENT_BY_ID + environmentId
    return AXIOS.get(apiEndPointConfig).then(response => {
      return response.data
    })
  },

  getSrcKeys (environmentId) {
    const apiEndPointConfig = ENDPOINTS.API.GET_SRC_KEYS + environmentId
    return AXIOS.get(apiEndPointConfig).then(response => {
      return response.data
    })
  },

  getSrcConfiguration (environment) {
    const apiEndPointConfig = ENDPOINTS.API.GET_SRC_CONFIG_BY_ENVIRONMENT + environment
    return AXIOS.get(apiEndPointConfig).then(response => {
      return response.data
    })
  },

  confirmation (confirmation) {
    const apiEndPointConfig = ENDPOINTS.API.CONFIRMATION
    return AXIOS.post(apiEndPointConfig, confirmation).then(response => {
      return response.data
    })
  },

  getSrcPayload (srcApiInputs) {
    const apiEndPointConfig = ENDPOINTS.API.PAYLOAD
    return AXIOS.post(apiEndPointConfig, srcApiInputs).then(response => {
      return response.data
    })
  },

  enrollCard (srcApiInputs) {
    const apiEndPointConfig = ENDPOINTS.API.ENROLL
    return AXIOS.post(apiEndPointConfig, srcApiInputs).then(response => {
      return response.data
    })
  },

  getFederatedToken (federatedTokenRequest) {
    const apiEndPointConfig = ENDPOINTS.API.FEDERATED_TOKEN_MTT
    return AXIOS_SHARED.post(apiEndPointConfig, federatedTokenRequest, {
      headers: {
        'Content-Type': 'text/plain'
      }
    }).then(response => {
      return response.data
    })
  },

  getFederatedTokenStart (federatedTokenRequest) {
    const apiEndPointConfig = ENDPOINTS.API.FEDERATED_TOKEN_START
    return AXIOS.post(apiEndPointConfig, federatedTokenRequest).then(response => {
      return response.data
    })
  },

  getUserAccess (params) {
    const correlationId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16))
    const apiEndPointConfig = ENDPOINTS.API.GET_USER_ACCESS
    return AXIOS.post(apiEndPointConfig, params, {
      headers: {
        'start-correlation-id': correlationId
      }
    }).then(response => {
      return response.data
    })
  },

  consumerLogin (srcApiInputs) {
    const correlationId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16))
    const apiEndPointConfig = ENDPOINTS.API.CONSUMER_LOGIN
    return AXIOS.post(apiEndPointConfig, srcApiInputs, {
      headers: {
        'start-correlation-id': correlationId
      }
    })
  },

  consumerRegistration (srcApiInputs) {
    const correlationId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16))
    const apiEndPointConfig = ENDPOINTS.API.CONSUMER_REGISTRATION
    return AXIOS.post(apiEndPointConfig, srcApiInputs, {
      headers: {
        'start-correlation-id': correlationId
      }
    })
  },

  forgotPwd (params) {
    const correlationId = this.generateUUID()
    const apiEndPointConfig = ENDPOINTS.API.FORGET_PWD
    return AXIOS.post(apiEndPointConfig, params, {
      headers: {
        'start-correlation-id': correlationId
      }
    }).then(response => {
      return response.data
    })
  },

  resetPwd (params) {
    const correlationId = this.generateUUID()
    const apiEndPointConfig = ENDPOINTS.API.RESET_PWD
    return AXIOS.post(apiEndPointConfig, params, {
      headers: {
        'start-correlation-id': correlationId
      }
    }).then(response => {
      return response.data
    })
  },

  generateUUID () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16))
  },

  async getSignatureHeader (requestBody) {
    const apiEndpoint = ENDPOINTS.API.GET_SIGNATURE_HEADER
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  },

  async getCheckoutResponseJWS (requestBody, param = 'start') {
    const apiEndpoint = ENDPOINTS.API.CHECKOUT_PAYLOAD + param
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  },

  async getConfirmationApiResponse (requestBody, param = 'start') {
    const apiEndpoint = ENDPOINTS.API.CONFIRMATION_API + param
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  },

  async getBindMfaApiResponse (requestBody, param = 'bindmfa') {
    const apiEndpoint = ENDPOINTS.API.BIND_MFA + param
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  },

  async getScofPayloadApiResponse (requestBody) {
    const apiEndpoint = ENDPOINTS.API.SRC_SCOF_PAYLOAD
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  },

  async getB2BAuthLookupApiResponse (requestBody) {
    const apiEndpoint = ENDPOINTS.API.B2B_AUTH_LOOKUP
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  },

  async getTAVGenerateApiResponse (requestBody) {
    const apiEndpoint = ENDPOINTS.API.TAV_GENERATE
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  },

  async getB2BAuthenticateApiResponse (requestBody) {
    const apiEndpoint = ENDPOINTS.API.MDES_AUTHENTICATE
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  },

  async getCardDetails (requestBody) {
    const apiEndPoint = ENDPOINTS.API.GET_CARD
    const response = await AXIOS.post(apiEndPoint, requestBody)
    return response.data
  },

  async getScofResultApiResponse (requestBody) {
    const apiEndpoint = ENDPOINTS.API.SCOF_RESULT
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  },

  async getThirdPartyPKIData (requestBody) {
    const apiEndpoint = ENDPOINTS.API.THIRD_PARTY_PKI_DATA
    const response = await AXIOS.post(apiEndpoint, requestBody)
    return response.data
  }

}
export default api
